import img1 from "../Assets/Images/1.jpg";
import img2 from "../Assets/Images/2.jpg";
import img3 from "../Assets/Images/3.jpg";
import img4 from "../Assets/Images/4.jpg";
import img5 from "../Assets/Images/5.jpg";
import img6 from "../Assets/Images/6.jpg";
import img7 from "../Assets/Images/7.jpg";
import img8 from "../Assets/Images/8.jpg";

export const DistrictData = [
  {
    id: 1,
    img: img1,
    districtName: "Sargodha",
    path: "/demo",
  },
  {
    id: 2,
    img: img2,
    districtName: "Lahore",
    path: "/demo",
  },
  {
    id: 3,
    img: img3,
    districtName: "Sialkot ",
    path: "/demo",
  },
  {
    id: 4,
    img: img4,
    districtName: "DI Khan",
    path: "/demo",
  },
  {
    id: 5,
    img: img5,
    districtName: "Bannu",
    path: "/demo",
  },
  {
    id: 6,
    img: img6,
    districtName: "DG Khan",
    path: "/demo",
  },
  {
    id: 7,
    img: img7,
    districtName: "Gujranwala",
    path: "/demo",
  },
  {
    id: 8,
    img: img8,
    districtName: "Gujrat",
    path: "/demo",
  },
];
